export const BI_CHART_DIMENSIONS = [
    {
        key: 'ANCS',
        title: {
            cn: '所有者',
            en: 'Owner',
            tw: '所有者',
            jp: 'オーナー',
        },
    },
    {
        key: 'BENEFIT_PHRASE',
        title: {
            cn: '技术效果',
            en: 'Technical Advancement',
            tw: '技術效果',
            jp: '技術効果語',
        },
    },
    {
        key: 'BENEFIT_TP',
        title: {
            cn: '功效关系',
            en: 'Efficacy Topic',
            tw: '功效關係',
            jp: '効能関係',
        },
    },
    {
        key: 'ADC',
        title: {
            cn: '应用领域分类',
            en: 'Application Domain',
            tw: '應用領域分類',
            jp: '応用分野分類',
        },
    },
    {
        key: 'ADC_A',
        title: {
            cn: '应用领域1级',
            en: 'Application domain 1st level',
            tw: '應用領域1级',
            jp: '応用分野の第1階層',
        },
    },
    {
        key: 'ADC_B',
        title: {
            cn: '应用领域2级',
            en: 'Application domain 2nd level',
            tw: '應用領域2级',
            jp: '応用分野の第2階層',
        },
    },
    {
        key: 'ADC_C',
        title: {
            cn: '应用领域3级',
            en: 'Application domain 3rd level',
            tw: '應用領域3级',
            jp: '応用分野の第3階層',
        },
    },
    {
        key: 'ADC_D',
        title: {
            cn: '应用领域4级',
            en: 'Application domain 4th level',
            tw: '應用領域4级',
            jp: '応用分野の第4階層',
        },
    },
    {
        key: 'TTC',
        title: {
            cn: '技术主题分类',
            en: 'Technology Topic',
            tw: '技術主題分類',
            jp: '技術トピック分類',
        },
    },
    {
        key: 'TTC_CLUSTER_LA',
        title: {
            cn: '技术主题1级',
            en: 'Technology topic 1st level',
            tw: '技術主題1級',
            jp: 'トピック・ランク1',
        },
    },
    {
        key: 'TTC_CLUSTER_LB',
        title: {
            cn: '技术主题2级',
            en: 'Technology topic 2nd level',
            tw: '技術主題2級',
            jp: 'トピック・ランク2',
        },
    },
    {
        key: 'TTC_CLUSTER_LC',
        title: {
            cn: '技术主题3级',
            en: 'Technology topic 3rd level',
            tw: '技術主題3級',
            jp: 'トピック・ランク3',
        },
    },
    {
        key: 'TECH',
        title: {
            cn: '技术领域词',
            en: 'Technology Field Word',
            tw: '科技領域詞',
            jp: '技術分野の用語',
        },
    },
    {
        key: 'TECH_DOMAIN_ONE_ID',
        title: {
            cn: '技术领域1级',
            en: 'Technology field word 1st level',
            tw: '科技領域1級',
            jp: '技術分野1級',
        },
    },
    {
        key: 'TECH_DOMAIN_SEC_ID',
        title: {
            cn: '技术领域2级',
            en: 'Technology field word 2nd level',
            tw: '科技領域2級',
            jp: '技術分野2級',
        },
    },
    {
        key: 'COUNTRY',
        title: {
            cn: '受理局',
            en: 'Authority',
            tw: '受理局',
            jp: '受理官庁',
        },
    },
    {
        key: 'PATENT_TYPE',
        title: {
            cn: '专利类型',
            en: 'Patent Type',
            tw: '專利類型',
            jp: '特許タイプ',
        },
    },
    {
        key: 'SIMPLE_LEGAL_STATUS',
        title: {
            cn: '专利权状态',
            en: 'Patent Status',
            tw: '專利權狀態',
            jp: '特許権状態',
        },
    },
    {
        key: 'APD_Y',
        title: {
            cn: '申请年',
            en: 'Application Year',
            tw: '申請年',
            jp: '出願年',
        },
    },
    {
        key: 'IN_FACET',
        title: {
            cn: '发明人',
            en: 'Inventor',
            tw: '發明人',
            jp: '発明者',
        },
    },
    {
        key: 'PROBLEM_PHRASE_ID',
        title: {
            cn: '技术问题',
            en: 'Technical Problem Phrases',
            jp: '技術的な問題句',
            tw: '技術問題',
        },
    },
    {
        key: 'BENEFIT_THEME',
        title: {
            cn: '主题',
            en: 'Topic Word',
            jp: '主題詞',
            tw: '主題',
        },
    },
    {
        key: 'TECH_DOMAIN_ONE_ID',
        title: {
            cn: '技术领域1级',
            en: 'Technology Field Word 1st Level',
            jp: '技術分野1級',
            tw: '技術領域1級',
        },
    },
    {
        key: 'EUREKA_REFINE_KEYWORD',
        title: {
            cn: '关键词',
            en: 'Keyword',
            tw: '關鍵詞',
            jp: 'キーワード',
        },
    }
]

export const BI_CHART_DIMENSIONS_OTHER = [
    {
        key: 'APD_Y',
        title: {
            cn: '出版年',
            en: 'Publish Date',
            tw: '發布日期',
            jp: '公開日',
        },
    }
]
